import { getInstance } from '@portal/repositories/securitySdkConfig';

const BASE_URL = '/favored-contact';
const FavoredContactApi = {
  getFavoredContact: async () => {
    const instance = getInstance();
    const { data } = await instance.get(BASE_URL);

    return data as models.PaginationResponse<models.Contact>;
  },

  createFavoredContact: async (favoredContact: models.Contact) => {
    const instance = getInstance();
    const { data } = await instance.post(BASE_URL, favoredContact);

    return data as models.Contact;
  },

  deleteFavoredContact: async (id: string) => {
    const instance = getInstance();
    await instance.delete(`${BASE_URL}/${id}`);
  },

  favoriteFavoredContact: async (body: { isFavorite: boolean }, id: string) => {
    const instance = getInstance();
    await instance.put(`${BASE_URL}/${id}/set-favorite`, body);
  },
};

export default FavoredContactApi;
